import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';
import {
  SummarySectionContainer,
  SummaryOption,
} from './styles/SummarySections.styled';
import {
  generateReactKey,
  KeyRoots,
} from 'src/utils/generateUniqueReactKey/generateUniqueReactKey';

interface SummarySectionProps {
  options: { [key: string]: number };
  loadingVacationPeriod: boolean;
}

export const SummarySection = ({
  options,
  loadingVacationPeriod,
}: SummarySectionProps) => {
  return (
    <SummarySectionContainer>
      {!loadingVacationPeriod ? (
        Object.entries(options).map(([key, value], index) => (
          <SummaryOption
            key={generateReactKey(KeyRoots.TIME_OFF_SUMMARY_SECTION, index)}
          >
            <p>{value}</p>
            <p>{key}</p>
          </SummaryOption>
        ))
      ) : (
        <LoadingSpinner />
      )}
    </SummarySectionContainer>
  );
};
